import { createFileRoute } from "@tanstack/react-router";
import { InvoicePage } from "~/features/sales/invoice-page";

export const Route = createFileRoute("/_app/invoices/new")({ component: () => <InvoicePage /> });
